module.exports = __webpack_public_path__ + "assets/quote_avatar_1.22f7ee35.png";